import sortBy from 'lodash.sortby'

export default function getNextDiscountLv(items, totalOrderAmountWithCoupon) {
  return sortBy(items, item => item.amount)
    .find(item => totalOrderAmountWithCoupon < item.amount)
}
